import { createFileRoute } from '@tanstack/react-router';
import { ClerkScope } from '../auth/ClerkScope';
import { RequireAuth } from '../auth/RequireAuth';
import { QuickstartKeyProvider } from '../features/keys/QuickstartKeyProvider';
import { ConnectSurfaceScope } from '../features/connect/connectTelemetry';
import { WelcomePage } from '../pages/welcome/WelcomePage';

/**
 * The post-signup welcome, standing on its own outside the dashboard shell.
 *
 * It mounts the same Clerk scope and guard the dashboard does - it reads an
 * identity and it is not a marketing page - but none of the dashboard chrome,
 * because it runs before a reader has a dashboard to navigate.
 *
 * The connect step is the same component the dashboard's Connect tab draws,
 * so the surface it is being read on is named here.
 *
 * `QuickstartKeyProvider` comes along because the connect step shows the
 * account's own key inside the prompt it asks the reader to paste. It is not
 * dashboard-specific: it owns the first key an account gets, which is exactly
 * what this page hands over. Its eager mint is off here, because the page mints
 * the key at the step that gives it to the reader rather than on arrival.
 */
export const Route = createFileRoute('/welcome')({
  ssr: false,
  component: WelcomeRoute,
});

function WelcomeRoute() {
  return (
    <ClerkScope>
      <RequireAuth>
        <QuickstartKeyProvider autoMint={false}>
          <ConnectSurfaceScope surface="welcome">
            <WelcomePage />
          </ConnectSurfaceScope>
        </QuickstartKeyProvider>
      </RequireAuth>
    </ClerkScope>
  );
}
